export default __webpack_public_path__ + "static/media/psycologist.156d4cc1.png";